export default function authHeader() {
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { Authorization: 'Bearer ' + user.token }; // for MVC Api  Boot back-end when methods has the Authorize 
  } else {
    return {};
  }
}
